module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('notification-behavioral', {
    ref: "notificationBase",
    staticClass: "notification-pricing-noted",
    attrs: {
      "item": _vm.item,
      "behaviors": _vm.behaviors
    },
    on: {
      "behaviorCompleted:note": _vm.handleNoteSent
    }
  }, [_c('template', {
    attrs: {
      "slot": "title",
      "item": _vm.item
    },
    slot: "title"
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("(" + _vm._s(_vm.item.customerId) + ") " + _vm._s(_vm.item.customerName) + " - " + _vm._s(_vm.item.title) + " "), _c('a', {
    attrs: {
      "href": '/partner/customer/index/id/' + _vm.item.customerId
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-globe"
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, _vm._l((_vm.item.notes), function(n) {
    return _c('div', {}, [_c('div', [_vm._v(_vm._s(n.createdBy) + " @ " + _vm._s(n.createdAt))]), _vm._v(" "), _c('div', [_c('pre', [_vm._v(_vm._s(n.note))])])])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "behaviors"
    },
    slot: "behaviors"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fce609d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/behaviors/PricingNoted.vue
// module id = 1105
// module chunks = 0